<template>
  <div class="container mx-auto mt-10 mb-8" v-if="!isSameObject(object, base)">
    <div class="relative flex flex-col sm:flex-row sm:items-center bg-white shadow rounded-md py-5 pl-6 pr-8 sm:pr-6">
      <div class="flex flex-row items-center border-b sm:border-b-0 w-full sm:w-auto pb-4 sm:pb-0">
        <div>
          <span
            class="inline-flex text-white rounded-full h-6 px-3 justify-center items-center"
            :class="'bg-' + color">{{ title }}</span>
        </div>
      </div>
      <div
        class="text-sm tracking-wide mt-4 sm:mt-0 sm:ml-4"
        :class="'text-' + color">{{ message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonUiAlert',
  props: {
    type: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    base: {
      type: Object,
      required: true
    },
    object: {
      type: Object,
      required: true
    }
  },
  computed: {

    title () {
      switch (this.type) {
      case 'warning':
        return 'Warning'
      default:
        return 'Info'
      }
    },

    color () {
      switch (this.type) {
      case 'warning':
        return 'yellow-600'
      default:
        return 'gray-500'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ui/alert.vue